import React from 'react';
import './wedding_deals.css';
import { FaCheckCircle } from 'react-icons/fa';

const WeddingDeals = () => {
    const packagesData = [
        {
            id: 1,
            title: 'Destination Wedding Package',
            description: 'Perfect for all your destination wedding venue and vendor needs.',
            price: '1999',
            originalPrice: '4999',
            features: [
                'Find venues with all-inclusive pricing (rooms, 3 meals, and event spaces), with available dates and quotes that fit your budget.',
                'Get personalized vendor recommendations for photographers, decorators, planners, caterers, makeup artists, and more.'
            ],
            isRecommended: false
        },
        {
            id: 2,
            title: 'City Wedding Package',
            description: 'Ideal for hometown or local wedding planning.',
            price: '749',
            originalPrice: '2999',
            features: [
                'Receive venue suggestions with date availability and quotes tailored to your budget and location.',
                'Get expert vendor recommendations in any 5 categories of your choice.',
                'One video meeting for personalized assistance.'
            ],
            isRecommended: true 
        },
        {
            id: 3,
            title: 'Single Wedding Service',
            description: 'Ideal for venue booking or single wedding service.',
            price: '100',
            originalPrice: '599',
            features: [
                'Tailored suggestions for venues or vendors (Based on your selection), customized to your budget and preferred location (One city).',
                'Expert price negotiations to ensure the best deals.'
            ],
            isRecommended: false
        }
    ];

    return (
        <section className="select-package-section container m-auto p-0">
            <h2 className="section-title my-3">Wedding Deals</h2>
            <div className="packages-grid">
                {packagesData.map((pkg) => (
                    <div key={pkg.id} className={`package-card ${pkg.isRecommended ? 'recommended' : ''}`}>
                        <h3 className="package-title">{pkg.title}</h3>
                        <p className="package-description">{pkg.description}</p>
                        <div className="price-container">
                            <span className="package-price">₹{pkg.originalPrice}/-</span>
                            {/* <del className="original-price">₹{pkg.originalPrice}/-</del> */}
                        </div>
                        <ul className="features-list">
                            {pkg.features.map((feature, index) => (
                                <li key={index} className="feature-item">
                                    <FaCheckCircle className="check-icon" />
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WeddingDeals;